export default __webpack_public_path__ + "static/media/AnimalPage3.47e2741e.txt";